module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "text-center",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "footer-text"
  }, [_vm._v("© " + _vm._s(_vm.getFullYear()) + "\n            "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v("\n            |  \n          "), _c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                "), _c('a', {
    attrs: {
      "href": "https://github.com/ICJIA/icjia-gata"
    }
  }, [_vm._v("View on GitHub")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d722cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 363
// module chunks = 0